export default {
  set(state, { data }) {
    state.users = data;
  },
  show(state, { data }) {
    state.user = data;
  },
  getPage(state, { data }) {
    state.page = data
  }
}